module.exports = __webpack_public_path__ + "media/g_4.bd3a7d68.mp3";